import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

import UserInfoCard from './components/User-details';
import Svgs from '../Common/Svgs';
import { getCurrentUser } from './epics-users';
import { StaticRoutePaths } from '../Common/ClientRoutes';

import localStorage from '../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

class UserInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingSpinner: false,
            role: '',
            name: '',
            email: '',
            phone: ''
        };
    }

    componentDidMount() {
        this.setState({
            ...this.state,
            loadingSpinner: true
        });
        getCurrentUser()
            .then(response => {
                this.setState({
                    loadingSpinner: false,
                    role: response.role,
                    name: response.names,
                    email: response.email,
                    phone: response.phone
                });
            })
            .catch(() => {
                this.setState({
                    loadingSpinner: false,
                    role: '',
                    name: '',
                    email: '',
                    phone: ''
                });
            });
    }

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.users}</span>
                    </div>

                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-info-circle mr-2" />
                                    {strings.user_info}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to={StaticRoutePaths.HOME} className="qf-back-btn">
                                    <i className="fa fa-chevron-left" />
                                    {strings.back}
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>
                        {this.state.loadingSpinner ? (
                            <div className="col-11 white-bg px-5 text-center p-3">
                                <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                            </div>
                        ) : (
                            <UserInfoCard {...this.state} />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(UserInformation);



// WEBPACK FOOTER //
// ./src/customModules/Users/component-user-info.js